import React, { forwardRef } from "react";
import { Icon } from "@/components/Icon";
import { useTranslation } from "react-i18next";

export interface SearchInputProps
    extends Omit<
        React.InputHTMLAttributes<HTMLInputElement>,
        "value" | "onChange"
    > {
    value: string;
    onChange: (value: string) => void;
    onClear?: () => void;
    placeholder?: string;
    wrapperClassName?: string;
}

export const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(
    (
        {
            value,
            onChange,
            onClear,
            placeholder,
            className = "",
            wrapperClassName = "",
            ...props
        },
        ref
    ) => {
        const { t } = useTranslation("global");

        const handleClear = () => {
            onChange("");
            if (onClear) {
                onClear();
            }
        };

        return (
            <div className={`relative ${wrapperClassName}`}>
                <Icon
                    value="search"
                    size={16}
                    className="text-slate-400 absolute left-3.5 top-1/2 -translate-y-1/2 pointer-events-none"
                />
                <input
                    ref={ref}
                    type="search"
                    aria-label={
                        props["aria-label"] ||
                        placeholder ||
                        t("table.search_placeholder")
                    }
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    placeholder={placeholder || t("table.search_placeholder")}
                    className={`w-full pl-10 pr-9 py-2.5 bg-white dark:bg-dark-box border border-slate-200 dark:border-white/20 rounded-lg text-xs text-slate-800 dark:text-zinc-100 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition-all shadow-xs ${className}`}
                    {...props}
                />
                {value && (
                    <button
                        type="button"
                        aria-label={t("workspace.list.clear_search")}
                        onClick={handleClear}
                        className="absolute right-2.5 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center rounded-full text-slate-400 hover:text-slate-600 hover:bg-slate-200/60 dark:hover:bg-white/10 transition-colors cursor-pointer"
                    >
                        <Icon value="x" size={20} />
                    </button>
                )}
            </div>
        );
    }
);

SearchInput.displayName = "SearchInput";
export default SearchInput;
